// extracted by mini-css-extract-plugin
export default {"button":"google-pay-button_button__c0280","google-pay-button":"google-pay-button_google-pay-button__52368"};